module.exports = __webpack_public_path__ + "img/ufuncoupon.fc548769.png";